import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { logErrorAndRunFail } from '../../utils';

export interface UploadFileOption extends Partial<GeneralInvokeOption> {
  url: string;
  filePath?: string;
  files?: Array<string>;
  name: string;
  header?: Object;
  formData?: Object;
  timeout?: number;
}

// 将本地资源上传到服务器
export function uploadFile(option: UploadFileOption) {
  if (!option.url) {
    return logErrorAndRunFail(
      APINames.Native.UPLOAD_FILE,
      option,
      'parameter error: parameter.url should be String instead of Undefined.'
    );
  }
  if (!option.files) {
    if (!option.filePath) {
      return logErrorAndRunFail(
        APINames.Native.UPLOAD_FILE,
        option,
        'parameter error: parameter.filePath should be String instead of Undefined.'
      );
    }
    if (!option.name) {
      return logErrorAndRunFail(
        APINames.Native.UPLOAD_FILE,
        option,
        'parameter error: parameter.name should be String instead of Undefined.'
      );
    }
  } else {
    option.filePath = '';
    option.name = '';
  }
  return MacleJSBridge.beforeInvoke(APINames.Native.UPLOAD_FILE, option);
}
